import ChevronLeft from '~/icons/chevron-left.svg';
import React from 'react';
import { theme } from '~/theme';
import { useTranslation } from '~/shared/utils/translation';
import {
    StyledCheckoutBannerText,
    StyledCheckoutBannerTextDesktop,
    StyledCheckoutgoForwardText,
    StyledCheckoutgoForwardTextDesktop,
    StyledDiv,
    StyledIconButtonCheckoutBannerButton,
    StyledIconButtonCheckoutBannerDesktop,
    StyledLoginButton,
} from './styled';
import { useBasket } from '~/features/basket';
import { useLocalBasketState } from '~/features/basket/hooks/useLocalBasketState';
import { usePaymentDetails } from '~/features/commerce-api/hooks/usePaymentDetails';

type Props = {
    textColor: string;
    onCloseBanner?: () => void;
    onGoBackClick?: () => void;
    onGoForwardClick?: () => void;
    onLoginButtonClick?: () => void;
    goForwardText?: string;
    goBackText?: string;
    goBackTextDefault?: string;
    bannerTextAlignStart?: boolean;
    desktop?: boolean;
    bannerText?: string;
    isUserLoggedIn?: boolean;
};
export const CheckoutBanner = (props: Props) => {
    const { translate } = useTranslation();
    const {
        textColor,
        bannerTextAlignStart,
        desktop,
        bannerText,
        onGoBackClick,
        onLoginButtonClick,
        onGoForwardClick,
        goForwardText,
        goBackText,
        isUserLoggedIn,
    } = props;

    const basket = useBasket();
    const { itemAccumulatedCount } = basket;
    const { membership } = useLocalBasketState();
    const { remainingTotal } = usePaymentDetails(basket, membership);

    if (desktop) {
        return (
            <StyledDiv>
                <StyledIconButtonCheckoutBannerDesktop children={<ChevronLeft />} />

                <StyledCheckoutBannerTextDesktop textColor={textColor} withCloseBanner={false}>
                    {bannerText}
                </StyledCheckoutBannerTextDesktop>
                {!isUserLoggedIn && (
                    <StyledLoginButton
                        onClick={onLoginButtonClick}
                        checkout
                        textColor={theme.colors.black}
                        metaMenu
                    />
                )}
                {isUserLoggedIn && (
                    <StyledCheckoutgoForwardTextDesktop
                        textColor={textColor}
                        withCloseBanner={false}
                        onClick={onGoForwardClick}
                    >
                        {goForwardText}
                    </StyledCheckoutgoForwardTextDesktop>
                )}
            </StyledDiv>
        );
    } else {
        return (
            <>
                <StyledCheckoutBannerText
                    textColor={textColor}
                    bannerTextAlignStart={true}
                    onClick={onGoBackClick}
                >
                    <StyledIconButtonCheckoutBannerButton
                        variant="plain"
                        children={
                            <>
                                <ChevronLeft style={{ height: 12, width: 12 }} />
                                {goBackText}
                            </>
                        }
                    />
                </StyledCheckoutBannerText>

                <StyledCheckoutBannerText
                    textColor={textColor}
                    withCloseBanner={false}
                    bannerTextAlignStart={bannerTextAlignStart}
                    flexGrow={true}
                >
                    {
                        <>
                            {itemAccumulatedCount() > 1 ? (
                                <>
                                    {itemAccumulatedCount()}{' '}
                                    {translate('checkout.checkout.multiple.products')}
                                </>
                            ) : (
                                <>
                                    {itemAccumulatedCount()}{' '}
                                    {translate('checkout.checkout.single.product')}
                                </>
                            )}
                            <span>{remainingTotal}</span>
                        </>
                    }
                </StyledCheckoutBannerText>

                {!isUserLoggedIn && (
                    <StyledCheckoutgoForwardText
                        textColor={textColor}
                        withCloseBanner={false}
                        onClick={onGoForwardClick}
                    >
                        <StyledLoginButton
                            onClick={onLoginButtonClick}
                            checkout
                            textColor={theme.colors.black}
                            metaMenu
                            mobile
                        />
                    </StyledCheckoutgoForwardText>
                )}
                {isUserLoggedIn && (
                    <StyledCheckoutgoForwardText
                        textColor={textColor}
                        withCloseBanner={false}
                        onClick={onGoForwardClick}
                    >
                        {goForwardText}
                    </StyledCheckoutgoForwardText>
                )}
            </>
        );
    }
};
